module.exports = __webpack_public_path__ + "static/media/logo.24bbc1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 905
// module chunks = 82